import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IPriceSnapshotState } from './pricesnapshot.types';
import { IPriceSnapshotData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IPriceSnapshotState = {
  version: 1,
  count: 0,
  priceSnapshots: [] as IPriceSnapshotData[]
};

const namespaced = true;

export const priceSnapshot: Module<IPriceSnapshotState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
